const RequestCompOffAdminActionType = {
	/** ****************************** REQUEST COMP OFF ADMIN *********************** */
	REQUEST_COMPOFF_ADMIN_START: 'request_compoff_admin_start',
	REQUEST_COMPOFF_ADMIN_SUCCESS: 'request_compoff_admin_success',
	REQUEST_COMPOFF_ADMIN_FAILURE: 'request_compoff_admin_failure',
	REQUEST_COMPOFF_ADMIN_RESPONSE_CHANGED: 'request_compoff_admin_response_changed',
	REQUEST_COMPOFF_ADMIN_RESPONSE_REST_START: 'request_compoff_admin_response_rest_start',
	/** ****************************** GET ALL EMPLOYEES FOR COMP OFF ADMIN *********************** */
	GET_ALL_EMPLOYEES_COMPOFF_ADMIN_START: 'get_all_employees_compoff_admin_start',
	GET_ALL_EMPLOYEES_COMPOFF_ADMIN_SUCCESS: 'get_all_employees_compoff_admin_success',
	GET_ALL_EMPLOYEES_COMPOFF_ADMIN_FAILURE: 'get_all_employees_compoff_admin_failure',
	GET_ALL_EMPLOYEES_COMPOFF_ADMIN_RESPONSE_CHANGED: 'get_all_employees_compoff_admin_response_changed',
	GET_ALL_EMPLOYEES_COMPOFF_ADMIN_RESPONSE_REST_START: 'get_all_employees_compoff_admin_response_rest_start',
	/** ****************************** GET HOLIDAYS *********************** */
	GET_HOLIDAYS_COMPOFF_ADMIN_START: 'get_holidays_compoff_admin_start',
	GET_HOLIDAYS_COMPOFF_ADMIN_SUCCESS: 'get_holidays_compoff_admin_success',
	GET_HOLIDAYS_COMPOFF_ADMIN_FAILURE: 'get_holidays_compoff_admin_failure',
	GET_HOLIDAYS_COMPOFF_ADMIN_RESPONSE_CHANGED: 'get_holidays_compoff_admin_response_changed',
	GET_HOLIDAYS_COMPOFF_ADMIN_RESPONSE_REST_START: 'get_holidays_compoff_admin_response_rest_start',

	// Encryption keys
	REQUEST_COMPOFF_ADMIN_KEY: 'RequestCompOffAdminFromWeb',
	GET_ALL_EMPLOYEES_COMPOFF_ADMIN_KEY: 'GetAllEmployeesForCompOffAdminFromWeb',
	GET_HOLIDAYS_COMPOFF_ADMIN_KEY: 'GetHolidaysForCompOffAdminFromWeb',
} as const;

export default RequestCompOffAdminActionType;

